import BackendConnector from './backendConnector';

export default class PublicPositionHttpService {
    static getPublicPositionDescription(positionId) {
        return BackendConnector.get(`public/position/${positionId}/description`);
    }

    static getPublicPositionApproval(positionApprovalUuid) {
        return BackendConnector.get(`public/position/${positionApprovalUuid}/approval`);
    }

    static approvePosition(positionApprovalUuid, candidateData) {
        return BackendConnector.post(`public/position/${positionApprovalUuid}/approve`, candidateData);
    }

    static rejectPosition(positionApprovalUuid, candidateData) {
        return BackendConnector.post(`public/position/${positionApprovalUuid}/reject`, candidateData);
    }

    static addCandidateAnswer(positionApprovalUuid, data) {
        return BackendConnector.post(`public/position/${positionApprovalUuid}/addCandidateAnswer`, data);
    }

    static alreadyApplied(positionApprovalUuid, data) {
        return BackendConnector.post(`public/position/${positionApprovalUuid}/alreadyApplied`, data);
    }
}
